import { render, staticRenderFns } from "./ApplicantDisclosures.vue?vue&type=template&id=27f1abc2&scoped=true&"
import script from "./ApplicantDisclosures.vue?vue&type=script&lang=js&"
export * from "./ApplicantDisclosures.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27f1abc2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VForm})
